import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useStore } from "../../context/StoreContext";
import { brl, imgUrl } from "../../lib/api";
import { logRequest, multiMessage, waLink } from "../../lib/whatsapp";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "../ui/sheet";

export default function SelectionDrawer() {
  const { selection, drawerOpen, setDrawerOpen, setQty, removeItem, clearSelection, settings } = useStore();
  const total = selection.reduce((s, i) => s + i.final_price * i.qty, 0);
  const href = settings?.whatsapp ? waLink(settings.whatsapp, multiMessage(selection)) : "#";

  return (
    <Sheet open={drawerOpen} onOpenChange={setDrawerOpen}>
      <SheetContent side="right" className="flex w-full flex-col border-l border-[#D4AF37]/20 bg-[#0B0B0C] p-0 sm:max-w-md" data-testid="selection-drawer">
        <div className="border-b border-[#D4AF37]/15 p-6">
          <SheetTitle className="font-serif text-3xl font-medium text-[#FAF6F0]">Minha seleção</SheetTitle>
          <SheetDescription className="mt-1 text-xs text-[#A1A1AA]">Envie todos os perfumes escolhidos em uma única mensagem pelo WhatsApp.</SheetDescription>
        </div>
        <div className="flex-1 space-y-4 overflow-y-auto p-6">
          {selection.length === 0 && (
            <div className="py-16 text-center text-sm text-[#A1A1AA]" data-testid="selection-empty">
              Nenhum perfume selecionado ainda.
              <Link to="/catalogo" onClick={() => setDrawerOpen(false)} className="btn-outline-gold mt-6 flex">Explorar catálogo</Link>
            </div>
          )}
          {selection.map((i) => (
            <div key={i.id} className="flex gap-4 rounded-xl border border-white/5 bg-[#141417] p-3" data-testid={`selection-item-${i.id}`}>
              <div className="h-20 w-16 shrink-0 overflow-hidden rounded-lg bg-black">
                {i.image && <img src={imgUrl(i.image)} alt={i.name} className="h-full w-full object-cover" />}
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-[10px] uppercase tracking-[0.2em] text-[#D4AF37]">{i.brand}</p>
                <p className="truncate font-serif text-lg text-[#FAF6F0]">{i.name}</p>
                <p className="text-sm text-[#F3E5AB]">{brl(i.final_price)}</p>
                <div className="mt-2 flex items-center gap-2">
                  <button onClick={() => setQty(i.id, i.qty - 1)} className="flex h-7 w-7 items-center justify-center rounded-full border border-white/10 text-[#A1A1AA] hover:border-[#D4AF37]/50" aria-label="Diminuir" data-testid={`selection-qty-minus-${i.id}`}><Minus className="h-3 w-3" /></button>
                  <span className="w-6 text-center text-sm" data-testid={`selection-qty-${i.id}`}>{i.qty}</span>
                  <button onClick={() => setQty(i.id, i.qty + 1)} className="flex h-7 w-7 items-center justify-center rounded-full border border-white/10 text-[#A1A1AA] hover:border-[#D4AF37]/50" aria-label="Aumentar" data-testid={`selection-qty-plus-${i.id}`}><Plus className="h-3 w-3" /></button>
                  <button onClick={() => removeItem(i.id)} className="ml-auto text-[#A1A1AA] hover:text-red-400" aria-label="Remover" data-testid={`selection-remove-${i.id}`}><Trash2 className="h-4 w-4" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {selection.length > 0 && (
          <div className="space-y-4 border-t border-[#D4AF37]/15 p-6">
            <div className="flex items-baseline justify-between">
              <span className="text-sm text-[#A1A1AA]">Total estimado</span>
              <span className="font-serif text-2xl text-[#F3E5AB]" data-testid="selection-total">{brl(total)}</span>
            </div>
            <a href={href} target="_blank" rel="noopener noreferrer" onClick={() => logRequest(selection)} className="btn-whatsapp w-full py-4" data-testid="whatsapp-drawer-submit">
              <WhatsAppIcon /> Enviar seleção pelo WhatsApp
            </a>
            <button onClick={clearSelection} className="w-full text-xs text-[#A1A1AA] underline-offset-2 hover:underline" data-testid="selection-clear">Limpar seleção</button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
